/* ============================================================================
   DTF Studio — AI upscale (hand-written; NOT generated). window.DTFUpscale:
     • available()            → true when this browser can run the model on the graphics card (WebGPU)
     • upscale(canvas, opt)   → a canvas of exactly opt.W × opt.H: waifu2x swin_unet ×4 (MIT, nunif by nagadomi)
                                 run tile by tile with ONNX Runtime Web, transparency upscaled on its own and cut
                                 crisp for DTF, then resampled to the print size. Calls run one at a time (queued).
       opt: { kind: 'art' | 'jpeg' | 'photo', W, H, soft (keep soft alpha: glows), onProgress(fraction, text) }
     • prewarm(kind)          → download + compile a model in the background
   Models live in our R2 bucket (served by print-api /file/…), cached in the browser for later visits.
   Nothing leaves the customer's device; any failure throws so DTF.enhance falls back to the classic path.
   ========================================================================== */
(function () {
  'use strict';
  var ORT_VER = '1.30.0';
  var ORT_URL = 'https://cdn.jsdelivr.net/npm/onnxruntime-web@' + ORT_VER + '/dist/';
  var CFG = (window.SMN_CONFIG && window.SMN_CONFIG.dtf) || {};
  var BASE = CFG.modelBase || 'https://print-api.stickermint.workers.dev/file/models/waifu2x/swin_unet_2025/';
  var FILES = { art: 'art_scale4x.onnx', jpeg: 'art_noise3_scale4x.onnx', photo: 'photo_scale4x.onnx' };
  var TILE = 256, SCALE = 4, CACHE = 'dtf-models-v1';
  var ort = null, gpu = null, sess = {};

  function mk(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function ctx(c) { return c.getContext('2d', { willReadFrequently: true }); }
  function tick() { return new Promise(function (r) { setTimeout(r, 0); }); }

  async function available() {
    if (gpu !== null) return gpu;
    gpu = false;
    try { if (navigator.gpu) { var a = await navigator.gpu.requestAdapter({ powerPreference: 'high-performance' }); gpu = !!a; } } catch (e) { gpu = false; }
    return gpu;
  }
  async function loadOrt() {
    if (ort) return ort;
    ort = await import(ORT_URL + 'ort.webgpu.min.mjs');
    ort.env.wasm.wasmPaths = ORT_URL; ort.env.logLevel = 'error';
    return ort;
  }
  // model bytes: browser cache first (later visits cost nothing), then R2 with download progress
  async function modelBytes(kind, onP) {
    var url = BASE + FILES[kind], cache = null;
    try { cache = await caches.open(CACHE); var hit = await cache.match(url); if (hit) return new Uint8Array(await hit.arrayBuffer()); } catch (e) { cache = null; }
    var r = await fetch(url, { mode: 'cors' });
    if (!r.ok) throw new Error('model download failed (' + r.status + ')');
    var total = +r.headers.get('content-length') || 0, got = 0, parts = [], rd = r.body && r.body.getReader ? r.body.getReader() : null;
    if (!rd) { var ab = new Uint8Array(await r.arrayBuffer()); got = ab.length; parts.push(ab); }
    else for (;;) { var x = await rd.read(); if (x.done) break; parts.push(x.value); got += x.value.length; if (onP && total) onP(got / total); }
    var b = new Uint8Array(got), o = 0; parts.forEach(function (p) { b.set(p, o); o += p.length; });
    if (cache) try { await cache.put(url, new Response(b.slice(0), { headers: { 'Content-Type': 'application/octet-stream' } })); } catch (e2) { }
    return b;
  }
  async function session(kind, onP) {
    if (sess[kind]) return sess[kind];
    sess[kind] = (async function () {
      await loadOrt();
      var bytes = await modelBytes(kind, function (f) { if (onP) onP(f * 0.8, 'Downloading the AI model… ' + Math.round(f * 100) + '%'); });
      if (onP) onP(0.85, 'Warming up the AI…');
      // logSeverityLevel 3: the native logger's routine warnings would show as console errors (ort.env.logLevel doesn't reach it)
      var s = await ort.InferenceSession.create(bytes, { executionProviders: ['webgpu'], graphOptimizationLevel: 'all', logSeverityLevel: 3 });
      var meta = (s.inputMetadata && s.inputMetadata[0]) || {};
      return { s: s, inName: s.inputNames[0], outName: s.outputNames[0], inType: meta.type || 'float32', offset: null };
    })();
    try { return await sess[kind]; } catch (e) { sess[kind] = null; throw e; }
  }

  // ── fp16 ↔ fp32 (the model may want half floats) ──────────────────────────
  var f32 = new Float32Array(1), u32 = new Uint32Array(f32.buffer);
  function toHalf(v) { f32[0] = v; var x = u32[0], s = (x >>> 16) & 0x8000, e = ((x >>> 23) & 0xff) - 127 + 15, m = x & 0x7fffff; if (e <= 0) return s; if (e >= 31) return s | 0x7c00; return s | (e << 10) | ((m + 0x1000) >>> 13); }
  function fromHalf(h) { var s = h & 0x8000 ? -1 : 1, e = (h >>> 10) & 0x1f, m = h & 0x3ff; if (e === 0) return s * m * 5.960464477539063e-8; if (e === 31) return m ? NaN : s * Infinity; return s * Math.pow(2, e - 15) * (1 + m / 1024); }
  function tensor(type, data, dims) {
    if (type === 'float16') {
      if (typeof Float16Array !== 'undefined') return new ort.Tensor('float16', Float16Array.from(data), dims);
      var u = new Uint16Array(data.length); for (var i = 0; i < data.length; i++) u[i] = toHalf(data[i]); return new ort.Tensor('float16', u, dims);
    }
    return new ort.Tensor('float32', data, dims);
  }
  function asF32(t) {
    var d = t.data; if (d instanceof Float32Array) return d;
    if (typeof Float16Array !== 'undefined' && d instanceof Float16Array) return Float32Array.from(d);
    if (d instanceof Uint16Array) { var o = new Float32Array(d.length); for (var i = 0; i < d.length; i++) o[i] = fromHalf(d[i]); return o; }
    return Float32Array.from(d);
  }

  // ── tiled ×4: chw Float32(3·w·h, 0..1) → Float32(3·4w·4h). waifu2x trims a margin off each tile (probed once) ──
  async function runTiled(S, chw, w, h, onTile) {
    var T = TILE, s = SCALE;
    if (S.offset == null) { var pr = await S.s.run(mkIn(S, new Float32Array(3 * T * T).fill(0.5))); var OTp = pr[S.outName].dims[3]; S.offset = (T * s - OTp) / 2; if (pr[S.outName].dispose) pr[S.outName].dispose(); }
    var o = S.offset, c = Math.ceil(o / s) + 12, core = T - 2 * c;
    var nx = Math.ceil(w / core), ny = Math.ceil(h / core), PW = nx * core + 2 * c, PH = ny * core + 2 * c;
    var pad = new Float32Array(3 * PW * PH), ch, x, y;
    for (ch = 0; ch < 3; ch++) for (y = 0; y < PH; y++) { var sy = Math.min(h - 1, Math.max(0, y - c)); for (x = 0; x < PW; x++) { var sx = Math.min(w - 1, Math.max(0, x - c)); pad[ch * PW * PH + y * PW + x] = chw[ch * w * h + sy * w + sx]; } }
    var OW = w * s, OH = h * s, out = new Float32Array(3 * OW * OH), tile = new Float32Array(3 * T * T), OT = T * s - 2 * o, u0 = c * s - o, cs = core * s, n = 0;
    for (var ty = 0; ty < ny; ty++) for (var tx = 0; tx < nx; tx++) {
      var x0 = tx * core, y0 = ty * core;
      for (ch = 0; ch < 3; ch++) for (y = 0; y < T; y++) { var so = ch * PW * PH + (y0 + y) * PW + x0; tile.set(pad.subarray(so, so + T), ch * T * T + y * T); }
      var res = await S.s.run(mkIn(S, tile)), yt = res[S.outName], yd = asF32(yt);
      if (yt.dims[3] !== OT) throw new Error('unexpected model output');
      for (ch = 0; ch < 3; ch++) for (var v = 0; v < cs; v++) { var gy = ty * cs + v; if (gy >= OH) break; var src = ch * OT * OT + (v + u0) * OT + u0, dst = ch * OW * OH + gy * OW + tx * cs, len = Math.min(cs, OW - tx * cs); out.set(yd.subarray(src, src + len), dst); }
      if (yt.dispose) yt.dispose();
      n++; if (onTile) onTile(n, nx * ny);
      if (n % 4 === 0) await tick();
    }
    return out;
  }
  function mkIn(S, data) { var q = {}; q[S.inName] = tensor(S.inType, data, [1, 3, TILE, TILE]); return q; }

  // colour of (nearly) transparent pixels filled from their opaque neighbours, so the model never sees the black of α=0
  function bleedRGB(d, w, h) {
    var n = w * h, r = new Float32Array(n), g = new Float32Array(n), b = new Float32Array(n), ok = new Uint8Array(n), sr = 0, sg = 0, sb = 0, cnt = 0, i, x, y;
    for (i = 0; i < n; i++) if (d[i * 4 + 3] >= 96) { ok[i] = 1; r[i] = d[i * 4]; g[i] = d[i * 4 + 1]; b[i] = d[i * 4 + 2]; sr += r[i]; sg += g[i]; sb += b[i]; cnt++; }
    for (var it = 0; it < 16; it++) {
      var front = [];
      for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
        i = y * w + x; if (ok[i]) continue;
        var ar = 0, ag = 0, ab = 0, k = 0;
        for (var dy = -1; dy <= 1; dy++) { var yy = y + dy; if (yy < 0 || yy >= h) continue; for (var dx = -1; dx <= 1; dx++) { var xx = x + dx; if (xx < 0 || xx >= w || (!dx && !dy)) continue; var j = yy * w + xx; if (ok[j] === 1) { ar += r[j]; ag += g[j]; ab += b[j]; k++; } } }
        if (k) { r[i] = ar / k; g[i] = ag / k; b[i] = ab / k; front.push(i); }
      }
      if (!front.length) break;
      for (var q = 0; q < front.length; q++) ok[front[q]] = 1;
    }
    var mr = cnt ? sr / cnt : 128, mg = cnt ? sg / cnt : 128, mb = cnt ? sb / cnt : 128, chw = new Float32Array(3 * n);
    for (i = 0; i < n; i++) { if (!ok[i]) { r[i] = mr; g[i] = mg; b[i] = mb; } chw[i] = r[i] / 255; chw[n + i] = g[i] / 255; chw[2 * n + i] = b[i] / 255; }
    return chw;
  }
  function rgbCHW(d, n) { var o = new Float32Array(3 * n); for (var i = 0; i < n; i++) { o[i] = d[i * 4] / 255; o[n + i] = d[i * 4 + 1] / 255; o[2 * n + i] = d[i * 4 + 2] / 255; } return o; }
  function alphaCHW(d, n) { var o = new Float32Array(3 * n); for (var i = 0; i < n; i++) { var a = d[i * 4 + 3] / 255; o[i] = o[n + i] = o[2 * n + i] = a; } return o; }
  // resample with the browser's best smoothing, halving step by step when shrinking a lot
  function resample(src, W, H) {
    var cur = src;
    while (cur.width / 2 >= W * 1.05 && cur.height / 2 >= H * 1.05) { var t = mk(cur.width / 2, cur.height / 2), tx = t.getContext('2d'); tx.imageSmoothingEnabled = true; tx.imageSmoothingQuality = 'high'; tx.drawImage(cur, 0, 0, t.width, t.height); if (cur !== src) cur.width = cur.height = 1; cur = t; }
    if (cur.width === W && cur.height === H) return cur;
    var o = mk(W, H), x = o.getContext('2d'); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high'; x.drawImage(cur, 0, 0, W, H);
    if (cur !== src) cur.width = cur.height = 1;
    return o;
  }

  async function upscale(src, opt) {
    opt = opt || {};
    if (!(await available())) throw new Error('no WebGPU');
    var kind = FILES[opt.kind] ? opt.kind : 'art', onP = opt.onProgress || function () { };
    var w = src.width, h = src.height, n = w * h;
    if (16 * n > 64e6) throw new Error('too large for the AI step');
    var S = await session(kind, onP);
    var d = ctx(src).getImageData(0, 0, w, h).data, A = false;
    for (var i = 3; i < d.length; i += 4) if (d[i] < 255) { A = true; break; }
    onP(0.88, 'AI upscaling…'); await tick();
    var withA = A && 16 * n <= 8e6, steps = withA ? 2 : 1;
    var rgb = await runTiled(S, A ? bleedRGB(d, w, h) : rgbCHW(d, n), w, h, function (k, m) { onP(0.88 + 0.1 * (k / m) / steps, 'AI upscaling… ' + Math.round(100 * (k / m) / steps) + '%'); });
    var OW = w * SCALE, ON = OW * h * SCALE, al = null;
    if (A && withA) {
      var ao = await runTiled(S, alphaCHW(d, n), w, h, function (k, m) { onP(0.93 + 0.05 * k / m, 'AI upscaling… ' + Math.round(50 + 50 * k / m) + '%'); });
      al = new Float32Array(ON); for (var p = 0; p < ON; p++) al[p] = Math.min(1, Math.max(0, (ao[p] + ao[ON + p] + ao[2 * ON + p]) / 3));
    } else if (A) {
      var ac = mk(OW, h * SCALE), ax = ctx(ac); ax.imageSmoothingEnabled = true; ax.imageSmoothingQuality = 'high'; ax.drawImage(src, 0, 0, ac.width, ac.height);
      var ad = ax.getImageData(0, 0, ac.width, ac.height).data; al = new Float32Array(ON); for (var q = 0; q < ON; q++) al[q] = ad[q * 4 + 3] / 255; ac.width = ac.height = 1;
    }
    // compose at ×4, then to the exact print size; transparency ends crisp (DTF prints soft edges as a white haze)
    var big = mk(OW, h * SCALE), bx = ctx(big), id = bx.createImageData(big.width, big.height), o = id.data;
    for (var k2 = 0; k2 < ON; k2++) {
      o[k2 * 4] = rgb[k2] * 255 + 0.5; o[k2 * 4 + 1] = rgb[ON + k2] * 255 + 0.5; o[k2 * 4 + 2] = rgb[2 * ON + k2] * 255 + 0.5;
      o[k2 * 4 + 3] = al ? Math.max(0, Math.min(255, al[k2] * 255 + 0.5)) : 255;
    }
    bx.putImageData(id, 0, 0); rgb = al = null;
    var W = Math.round(opt.W || OW), H = Math.round(opt.H || h * SCALE), out = resample(big, W, H);
    if (out !== big) big.width = big.height = 1;
    if (A && !opt.soft) {
      var ox = ctx(out);
      for (var y = 0; y < H; y += 1024) {
        var hh = Math.min(1024, H - y), im = ox.getImageData(0, y, W, hh), dd = im.data;
        for (var a = 3; a < dd.length; a += 4) { var v = dd[a] / 255; if (v > 0 && v < 1) { v = Math.min(1, Math.max(0, (v - 0.35) / 0.3)); dd[a] = Math.round(v * v * (3 - 2 * v) * 255); } }
        ox.putImageData(im, 0, y);
      }
    }
    onP(1, 'Done');
    return out;
  }
  // one AI run at a time: two runs on one ONNX WebGPU session at once hang the tab for good
  var queue = Promise.resolve();
  function serial(fn) { var p = queue.then(fn, fn); queue = p.then(function () { }, function () { }); return p; }
  function prewarm(kind) { available().then(function (ok) { if (ok) serial(function () { return session(FILES[kind] ? kind : 'art'); }).catch(function () { }); }); }

  window.DTFUpscale = { available: available, upscale: function (src, opt) { return serial(function () { return upscale(src, opt); }); }, prewarm: prewarm, base: BASE };
})();
